import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  data() {
    return {
      options: [10, 20, 30],
    };
  },
  computed: {
    radius: {
      get() {
        let { radius } = this.$store.state;
        if (!radius) {
          radius = this.options[0];
          this.$store.commit('setRadius', radius);
        }
        return radius;
      },
      set(value) {
        const radius = value === '' ? this.options[0] : parseInt(value);
        this.$store.commit('setRadius', radius);
      },
    },
  },
  template: '#t-stockists-radius',
});
